import { FuelTypography, FuelIcon } from '@frete.com/fuel-react'
import styled, { css } from 'styled-components'
import { StyledSelectProps } from './types'

export const Wrapper = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.km6};
`

export const SelectedInput = styled.div<StyledSelectProps>`
  position: relative;
  align-items: center;
  display: flex;
  border-radius: ${({ theme }) => theme.border.radius.medium};
  border-width: ${({ theme }) => theme.border.width.thinner};
  border-style: ${({ theme }) => theme.border.style.solid};
  border-color: ${({ theme }) => theme.color.border.neutral.default};
  width: 100%;
  height: 48px;
  cursor: pointer;

  :hover {
    border-color: ${({ theme }) => theme.color.border.neutral.strong};
  }

  ${({ $selected }) =>
    $selected &&
    css`
      border-color: ${({ theme }) => theme.color.border.neutral.strong};
    `}

  ${({ $focus }) =>
    $focus &&
    css`
      border-color: ${({ theme }) => theme.color.border.neutral.strong};
      box-shadow: ${({ theme }) => theme.color.focus.neutral.default} 0px 0px 0px 4px;
    `}

  ${({ $error }) =>
    $error &&
    css`
      border-color: ${({ theme }) => theme.color.border.danger.default};
      :hover {
        border-color: ${({ theme }) => theme.color.border.danger.default};
      }
    `}
`

export const Label = styled(FuelTypography).attrs({ size: 'caption', color: 'neutral-strong', weight: 'bold' })`
  margin-bottom: ${({ theme }) => theme.spacing.km3};
`

export const Selected = styled(FuelTypography).attrs({ size: 'body-sm', color: 'neutral-strong', weight: 'regular' })`
  margin-left: ${({ theme }) => theme.spacing.km3};
`

export const Placeholder = styled(FuelTypography).attrs({ size: 'body-sm', color: 'neutral-weak', weight: 'regular' })`
  margin-left: ${({ theme }) => theme.spacing.km3};
`

export const ChevronUp = styled(FuelIcon).attrs({ name: 'chevron-up' })`
  position: absolute;
`

export const ChevronDown = styled(FuelIcon).attrs({ name: 'chevron-down' })`
  position: absolute;
  top: 50%;
  left: calc(100% - ${({ theme }) => theme.spacing.km3});
  transform: translate(-100%, -50%);
`
